function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import Emitter from 'component-emitter';
import has from '@uppy/utils/lib/hasProperty';
import NetworkError from '@uppy/utils/lib/NetworkError';
import fetchWithNetworkError from '@uppy/utils/lib/fetchWithNetworkError';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore untyped

var ASSEMBLY_UPLOADING = 'ASSEMBLY_UPLOADING';
var ASSEMBLY_EXECUTING = 'ASSEMBLY_EXECUTING';
var ASSEMBLY_COMPLETED = 'ASSEMBLY_COMPLETED';
var statusOrder = [ASSEMBLY_UPLOADING, ASSEMBLY_EXECUTING, ASSEMBLY_COMPLETED];

/**
 * Check that an assembly status is equal to or larger than some desired status.
 * It checks for things that are larger so that a comparison like this works,
 * when the old assembly status is UPLOADING but the new is FINISHED:
 *
 * !isStatus(oldStatus, ASSEMBLY_EXECUTING) && isStatus(newState, ASSEMBLY_EXECUTING)
 *
 * …so that we can emit the 'executing' event even if the execution step was so
 * fast that we missed it.
 */
function isStatus(status, test) {
  return statusOrder.indexOf(status) >= statusOrder.indexOf(test);
}
var _rateLimitedQueue = /*#__PURE__*/_classPrivateFieldLooseKey("rateLimitedQueue");
var _fetchWithNetworkError = /*#__PURE__*/_classPrivateFieldLooseKey("fetchWithNetworkError");
var _previousFetchStatusStillPending = /*#__PURE__*/_classPrivateFieldLooseKey("previousFetchStatusStillPending");
var _sse = /*#__PURE__*/_classPrivateFieldLooseKey("sse");
var _onFinished = /*#__PURE__*/_classPrivateFieldLooseKey("onFinished");
var _connectServerSentEvents = /*#__PURE__*/_classPrivateFieldLooseKey("connectServerSentEvents");
var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
var _beginPolling = /*#__PURE__*/_classPrivateFieldLooseKey("beginPolling");
var _fetchStatus = /*#__PURE__*/_classPrivateFieldLooseKey("fetchStatus");
var _diffStatus = /*#__PURE__*/_classPrivateFieldLooseKey("diffStatus");
var TransloaditAssembly = /*#__PURE__*/function (_Emitter) {
  _inherits(TransloaditAssembly, _Emitter);
  function TransloaditAssembly(assembly, rateLimitedQueue) {
    var _this;
    _classCallCheck(this, TransloaditAssembly);
    _this = _callSuper(this, TransloaditAssembly);

    // The current assembly status.
    /**
     * Diff two assembly statuses, and emit the events necessary to go from `prev`
     * to `next`.
     */
    Object.defineProperty(_assertThisInitialized(_this), _diffStatus, {
      value: _diffStatus2
    });
    /**
     * Reload assembly status. Useful if SSE doesn't work.
     *
     * Pass `diff: false` to avoid emitting diff events, instead only emitting
     * 'status'.
     */
    Object.defineProperty(_assertThisInitialized(_this), _fetchStatus, {
      value: _fetchStatus2
    });
    /**
     * Begin polling for assembly status changes. This sends a request to the
     * assembly status endpoint every so often, if SSE connection failed.
     * If the SSE connection fails or takes a long time, we won't miss any
     * events.
     */
    Object.defineProperty(_assertThisInitialized(_this), _beginPolling, {
      value: _beginPolling2
    });
    Object.defineProperty(_assertThisInitialized(_this), _onError, {
      value: _onError2
    });
    Object.defineProperty(_assertThisInitialized(_this), _connectServerSentEvents, {
      value: _connectServerSentEvents2
    });
    Object.defineProperty(_assertThisInitialized(_this), _onFinished, {
      value: _onFinished2
    });
    Object.defineProperty(_assertThisInitialized(_this), _rateLimitedQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _fetchWithNetworkError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _previousFetchStatusStillPending, {
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), _sse, {
      writable: true,
      value: void 0
    });
    _this.status = assembly;
    // The interval timer for full status updates.
    _this.pollInterval = null;
    // Whether this assembly has been closed (finished or errored)
    _this.closed = false;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _rateLimitedQueue)[_rateLimitedQueue] = rateLimitedQueue;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _fetchWithNetworkError)[_fetchWithNetworkError] = rateLimitedQueue.wrapPromiseFunction(fetchWithNetworkError);
    return _this;
  }
  _createClass(TransloaditAssembly, [{
    key: "connect",
    value: function connect() {
      _classPrivateFieldLooseBase(this, _connectServerSentEvents)[_connectServerSentEvents]();
      _classPrivateFieldLooseBase(this, _beginPolling)[_beginPolling]();
    }
  }, {
    key: "update",
    value: function update() {
      return _classPrivateFieldLooseBase(this, _fetchStatus)[_fetchStatus]({
        diff: true
      });
    }

    /**
     * Update this assembly's status with a full new object. Events will be
     * emitted for status changes, new files, and new results.
     */
  }, {
    key: "updateStatus",
    value: function updateStatus(next) {
      _classPrivateFieldLooseBase(this, _diffStatus)[_diffStatus](this.status, next);
      this.status = next;
    }
    /**
     * Stop updating this assembly.
     */
  }, {
    key: "close",
    value: function close() {
      this.closed = true;
      if (_classPrivateFieldLooseBase(this, _sse)[_sse]) {
        _classPrivateFieldLooseBase(this, _sse)[_sse].close();
        _classPrivateFieldLooseBase(this, _sse)[_sse] = null;
      }
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }]);
  return TransloaditAssembly;
}(Emitter);
function _onFinished2() {
  this.emit('finished');
  this.close();
}
function _connectServerSentEvents2() {
  var _this2 = this;
  _classPrivateFieldLooseBase(this, _sse)[_sse] = new EventSource("".concat(this.status.websocket_url, "?assembly=").concat(this.status.assembly_id));
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('open', function () {
    clearInterval(_this2.pollInterval);
    _this2.pollInterval = null;
  });

  /*
   * The event "message" is a special case, as it
   * will capture events without an event field
   * as well as events that have the specific type
   * other event type.
   */
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('message', function (e) {
    if (e.data === 'assembly_finished') {
      _classPrivateFieldLooseBase(_this2, _onFinished)[_onFinished]();
    }
    if (e.data === 'assembly_uploading_finished') {
      _this2.emit('executing');
    }
    if (e.data === 'assembly_upload_meta_data_extracted') {
      _this2.emit('metadata');
      _classPrivateFieldLooseBase(_this2, _fetchStatus)[_fetchStatus]({
        diff: false
      });
    }
  });
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('assembly_upload_finished', function (e) {
    var file = JSON.parse(e.data);
    _this2.status.uploads.push(file);
    _this2.emit('upload', file);
  });
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('assembly_result_finished', function (e) {
    var _this$status$results, _this$status$results$;
    var _JSON$parse = JSON.parse(e.data),
      _JSON$parse2 = _slicedToArray(_JSON$parse, 2),
      stepName = _JSON$parse2[0],
      result = _JSON$parse2[1];
    ((_this$status$results$ = (_this$status$results = _this2.status.results)[stepName]) != null ? _this$status$results$ : _this$status$results[stepName] = []).push(result);
    _this2.emit('result', stepName, result);
  });
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('assembly_execution_progress', function (e) {
    var details = JSON.parse(e.data);
    _this2.emit('execution-progress', details);
  });
  _classPrivateFieldLooseBase(this, _sse)[_sse].addEventListener('assembly_error', function (e) {
    try {
      _classPrivateFieldLooseBase(_this2, _onError)[_onError](JSON.parse(e.data));
    } catch (_unused) {
      _classPrivateFieldLooseBase(_this2, _onError)[_onError](new Error(e.data));
    }
    // Refetch for updated status code
    _classPrivateFieldLooseBase(_this2, _fetchStatus)[_fetchStatus]({
      diff: false
    });
  });
}
function _onError2(assemblyOrError) {
  this.emit('error', Object.assign(new Error(assemblyOrError.message), assemblyOrError));
  this.close();
}
function _beginPolling2() {
  var _this3 = this;
  this.pollInterval = setInterval(function () {
    _classPrivateFieldLooseBase(_this3, _fetchStatus)[_fetchStatus]();
  }, 2000);
}
function _fetchStatus2(_x) {
  return _fetchStatus3.apply(this, arguments);
}
function _fetchStatus3() {
  _fetchStatus3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp) {
    var _ref, _ref$diff, diff, response, status;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _temp === void 0 ? {} : _temp, _ref$diff = _ref.diff, diff = _ref$diff === void 0 ? true : _ref$diff;
          if (!(this.closed || _classPrivateFieldLooseBase(this, _rateLimitedQueue)[_rateLimitedQueue].isPaused || _classPrivateFieldLooseBase(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending])) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.prev = 3;
          _classPrivateFieldLooseBase(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending] = true;
          _context.next = 7;
          return _classPrivateFieldLooseBase(this, _fetchWithNetworkError)[_fetchWithNetworkError](this.status.assembly_ssl_url);
        case 7:
          response = _context.sent;
          _classPrivateFieldLooseBase(this, _previousFetchStatusStillPending)[_previousFetchStatusStillPending] = false;
          if (!this.closed) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return");
        case 11:
          if (!(response.status === 429)) {
            _context.next = 14;
            break;
          }
          _classPrivateFieldLooseBase(this, _rateLimitedQueue)[_rateLimitedQueue].rateLimit(2000);
          return _context.abrupt("return");
        case 14:
          if (response.ok) {
            _context.next = 17;
            break;
          }
          _classPrivateFieldLooseBase(this, _onError)[_onError](new NetworkError(response.statusText));
          return _context.abrupt("return");
        case 17:
          _context.next = 19;
          return response.json();
        case 19:
          status = _context.sent;
          if (!this.closed) {
            _context.next = 22;
            break;
          }
          return _context.abrupt("return");
        case 22:
          this.emit('status', status);
          if (diff) {
            this.updateStatus(status);
          } else {
            this.status = status;
          }
          _context.next = 29;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](3);
          _classPrivateFieldLooseBase(this, _onError)[_onError](_context.t0);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, this, [[3, 26]]);
  }));
  return _fetchStatus3.apply(this, arguments);
}
function _diffStatus2(prev, next) {
  var _this4 = this;
  var prevStatus = prev.ok;
  var nextStatus = next.ok;
  if (next.error && !prev.error) {
    return _classPrivateFieldLooseBase(this, _onError)[_onError](next);
  }

  // Desired emit order:
  //  - executing
  //  - (n × upload)
  //  - metadata
  //  - (m × result)
  //  - finished
  // The below checks run in this order, that way even if we jump from
  // UPLOADING straight to FINISHED all the events are emitted as expected.

  var nowExecuting = isStatus(nextStatus, ASSEMBLY_EXECUTING) && !isStatus(prevStatus, ASSEMBLY_EXECUTING);
  if (nowExecuting) {
    // Without SSE, this is our only way to tell if uploading finished.
    // Hence, we emit this just before the 'upload's and before the 'metadata'
    // event for the most intuitive ordering, corresponding to the _usual_
    // ordering (if not guaranteed) that you'd get on SSE.
    this.emit('executing');
  }

  // Only emit if the upload is new (not in prev.uploads).
  Object.keys(next.uploads).filter(function (upload) {
    return !has(prev.uploads, upload);
  }).forEach(function (upload) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore either the types are wrong or the tests are wrong.
    // types think next.uploads is an array, but the tests pass an object.
    _this4.emit('upload', next.uploads[upload]);
  });
  if (nowExecuting) {
    this.emit('metadata');
  }

  // Find new results.
  Object.keys(next.results).forEach(function (stepName) {
    var nextResults = next.results[stepName];
    var prevResults = prev.results[stepName];
    nextResults.filter(function (n) {
      return !prevResults || !prevResults.some(function (p) {
        return p.id === n.id;
      });
    }).forEach(function (result) {
      _this4.emit('result', stepName, result);
    });
  });
  if (isStatus(nextStatus, ASSEMBLY_COMPLETED) && !isStatus(prevStatus, ASSEMBLY_COMPLETED)) {
    this.emit('finished');
  }
  return undefined;
}
export default TransloaditAssembly;